import AxiosService from './axios.service';
import {AxiosResponse} from 'axios';
import {UserBasic, UserBasicUpdate} from './types/types';


export class UserBasicService {
  // 🔐 GET /users (requiere JWT)
  static async findAll(): Promise<UserBasic[]> {
    const response: AxiosResponse<UserBasic[]> = await AxiosService.get('/users-basic');
    return response.data;
  }
  // 🔐 GET /users
  static async findAllZona(): Promise<string[]> {
    const response: AxiosResponse<string[]> = await AxiosService.get('/users-basic/zonas');
    return response.data;
  }

  // GET /users/:id
  static async findOne(id: string): Promise<UserBasic | null> {
    const response: AxiosResponse<UserBasic> = await AxiosService.get(`/users-basic/${id}`);
    return response.data;
  }
  
  // POST /users
  static async create(userData: UserBasic): Promise<UserBasic> {
    const response: AxiosResponse<UserBasic> = await AxiosService.post('/users-basic', userData);
    return response.data;
  }

  // 🔐 PUT /users/:id (requiere JWT + rol admin)
  static async update(id: string, userData: UserBasicUpdate): Promise<UserBasic | null> {
    const response: AxiosResponse<UserBasic> = await AxiosService.put(`/users-basic/${id}`, userData);
    return response.data;
  }

  // DELETE /users/:id
  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/users-basic/${id}`);
  }
}